import React from "react";
import "../../styles/LoadingSpinner.css";

const LoadingSpinner = ({
  size = "6rem",
  className = "",
  text = "Loading...",
}) => {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center ${className}`}
    >
      <div className="spinner-wrapper" style={{ width: size, height: size }}>
        {/*CENTER IMAGE  */}
        <img
          src="/assets/logo/loading.png"
          alt="WiSE Logo"
          className="spinner-center-image"
        />

        {/* ROTATING OUTER CIRCLE */}
        <svg className="spinner-rotating-ring" viewBox="0 0 120 120">
          <circle
            cx="60"
            cy="60"
            r="55"
            fill="none"
            stroke="#2c0446"
            strokeWidth="3"
            strokeDasharray="12 10"
            className="rotating-circle"
          />
        </svg>
      </div>

      {/* Loading Text */}
      <span className="loading-text">{text}</span>
    </div>
  );
};

export default LoadingSpinner;
